const SeriesNotFound = ({ agency = 'vindr' }) => {
  return (
    <div>
      <div className="mb-2 text-center text-xl">Dữ liệu ca chụp chưa sẵn sàng</div>
      <div className="mb-2 text-center text-xl italic">(The exam is currently unavailable)</div>
      <div className="text-center text-base">
        {`Vui lòng tải lại trang hoặc quay lại sau 24h nữa. Trường hợp vẫn không xem được hình ảnh, vui lòng liên hệ Hotline ${
          agency === 'vinmec' ? 'Vinmec ' : ''
        }để được hỗ trợ.`}
      </div>
      <div className="text-center text-base italic">
        {`(Please reload the page or try again after 24 hours. If you continue to have issues, contact the ${
          agency === 'vinmec' ? 'Vinmec ' : ''
        }Hotline for assistance.)`}
      </div>
    </div>
  );
};

export default SeriesNotFound;
